import StatsSection from "../components/StatsSection";
import Why from "../components/Why";
import Process from "../components/Process";

import illastration from "../assets/images/illastration-3.png";

function About() {
  return (
    <div>
      {
		<>		
		<section className="page-title custom-breadcrumb">
			<div className="overlay"></div>
			<div className="auto-container">
				<div className="content-box">
					<h1>About Company</h1>
					<ul className="bread-crumb"><li><a href="index.html">Home</a></li><li><span>→</span></li><li className="active">Company</li></ul>
				</div>
			</div>
		</section>
		
		<section className="about-modern">
			<div className="container">
				<div className="about-grid">
					<div className="about-images"><div className="img"><img src={illastration} alt="illastration" /></div></div>
					<div className="about-content">
						<h2>About DatroniQ</h2>
						<p>Datroniq is a modern data intelligence platform built to transform raw, scattered information into clear, actionable insights. In today’s fast-moving world, data is everywhere — but clarity is rare. That’s where Datroniq steps in.</p>
						<p>We don’t believe in simply collecting or selling data. Our focus is on identifying real signals hidden inside noise — filtering out irrelevant information and delivering only what truly matters.</p>
						<p>Every dataset we work with is refined through a structured process — ensuring it is not just available, but usable, relevant, and decision-ready.</p>
						<p>At its core, Datroniq exists for one purpose:</p>
						<p>👉 To help businesses move faster, decide smarter, and act with confidence.</p>						
					</div>
				</div>
			</div>
		</section>
		
		
		</>
	  }
    </div>
  );
}

export default About;